import React from 'react';
import { Divider, Icon } from 'antd';

const FormDivider = ({ children }) => (
  <Divider className={'divider_form'}>{children || <Icon type={'down-circle'} />}</Divider>
);

export default FormDivider;
